import { OPEN_DRAWER, CLOSE_DRAWER } from 'constants/actionTypes'
import { DRAWER } from 'constants/drawer'
import { Action } from 'actions'

const initialState = DRAWER.CLOSE

const drawerManager = (state = initialState, action: Action) => {
  switch (action.type) {
    case OPEN_DRAWER: {
      return DRAWER.OPEN
    }
    case CLOSE_DRAWER: {
      return DRAWER.CLOSE
    }
    default: {
      return state
    }
  }
}

export default drawerManager
